/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  lastEditedList: [],
};

const getters = {
  lastEditedsGuest: state => state.lastEditedList,
};

const actions = {
  fetch({ commit }, payload) {
    return Vue.http.get(`${getApiPath(payload.user)}/products/superadmin`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, lastEdites) {
    state.lastEditedList = lastEdites.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};




// WEBPACK FOOTER //
// ./src/store/modules/landlord/lastEditedsGuest.js